import React, { useState, useEffect } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import Table from '../_Components/AdminTable'
import Variables from '../../global'
import { call } from '../../Methods'
import { use } from '../../Helpers'

function _Items () {
  const pageTitle = 'Items'
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading,setLoading] = useState(true);

  let tableColumns = [
    {
      title: 'Image',
      property: 'image',
      type: 'image',
      mutate: value => {
        return `${Variables.base_url}/api/images/thumbnail-sm/${value}`
      }
    },
    {
      title: 'Serial',
      property: 'itemNumber',
      mutate: value => {
        return <b>{value || '-'}</b>
      }
    },
    {
      title: 'Name',
      property: 'itemName'
    },
    {
      title: 'Status',
      property: ['statusId','statusName'],
      type: 'label',
      mutate: values => {
        return (
          <span style={{ backgroundColor: use.colorsByValues(values[0]) }}>
            {values[1]}
          </span>
        )
      }
    },
    {
      title: 'Actions',
      type: 'actions-list',
      property: ['id'],
      mutate: value => {
        return (
          <>
            <Link to={`/admin/item/${value}`}>
              <img
                className='action-icon'
                title={'Edit'}
                src={'/Icons/edit.png'}
              />
            </Link>
          </>
        )
      }
    }
  ]

  const getData = async (parameters) => {
    setLoading(true);
    let _items = await call.forLoggedUser.item.getItems({});
    if(_items.success){
      setLoading(false);
      return _items;
    }
    return false;
  }

  useEffect(()=>{
    getData(use.userSettings());
  },[])

  return (
    <React.Fragment>
      <h3 className='page-title'>{pageTitle}</h3>
      <Table
        columns={tableColumns}
        loading={loading}
        //data={tableData?.data}
        getMethod={getData}
        addNew={{ enabled: true, url: '/admin/item/add' }}
        pagination={{
          enable:true,
          settings:{
            pageNumber: 1, //+searchParams.get("pageNumber") || 1
            pageSize: 10, //+searchParams.get("pageSize") || 10
            sort: 'asc', //searchParams.get("sort") || 'asc'
            length: 0, //tableData?.length || 0
            pageCount: 0 //tableData?.pageCount || 0
          }
        }}
      />
    </React.Fragment>
  )
}

export default _Items
